import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";
import { ErrorResponse } from "@models/Models";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const RegulationConsentHistoriesApiService = lazy(loadFailPath, ()=>import("@api-services/user/RegulationConsentHistoriesApiService"));

export class AcceptNewTermsService {
	async acceptRegulation() {
		try {
			await (
				await RegulationConsentHistoriesApiService
			).default.acceptRegulation();
			return new Response();
		} catch (error) {
			console.log(error);
			throw new ErrorResponse("GENERIC_ERROR");
		}
	}
}
